<template>
	<page-common type="normal"  :detail="detail">
		<div class="m-header">
			<h2 class="title f-taj">{{detail.title}}</h2>
			<div class="info">
				<span class="time">{{detail.newsDatetime}}</span>
				<span class="authors" v-if="detail.authors">{{detail.authors}}</span>
				<span class="copyfrom" v-if="detail.copyfrom">{{detail.copyfrom}}</span>
			</div>
		</div>
		<!--<div class="m-intro f-taj" v-if="detail.introduction">
			<em class="prefix">导语：</em>{{detail.introduction}}
		</div>-->
		<div class="m-detail">
			<div class="m-media" v-if="showMedias">
				<div class="media-item" v-for="(media, index) of detail.medias" :key="index">
					<div class="m-video" v-if="media.type === 'video'" :style="{height: videoH}">
						<video :src="media.sourceUrl" :poster="media.image" x-webkit-airplay="true" webkit-playsinline="true" preload="auto" controls>
						</video>
					</div>
					<audio-bar :src="media.sourceUrl" v-else-if="media.type === 'audio'"></audio-bar>
					<div class="m-img" v-else-if="media.type === 'img'">
						<img :src="media.image"/>
					</div>
					<p class="title f-taj" v-if="media.title">{{media.title}}</p>
					<p class="summary f-taj" v-if="media.description">{{media.description}}</p>
				</div>
			</div>
			<div class="m-content f-taj" v-if="detail.content" v-html="content"></div>
			<a class="open-full-btn" @click="openFullHandle">
			</a>
		</div>
	</page-common>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import * as device from 'constants/device'
import imgMixin from 'mixins/image'
import AudioBar from './common/audio-bar'
import PageCommon from './page-common'
// import 'styles/page-normal.less'
export default {
	mixins: [imgMixin],
	components: {
		AudioBar,
		PageCommon,
	},
	data() {
		return {
			openFull: true
		};
	},
	computed: {
		...mapGetters({
			detail: 'paper:detail',
			appW: 'app:width'
		}),
		content() {
			let vm = this;
			const contentW = this.appW - 20;
			let $content = $('<div>' + this.detail.content + '</div>');
			$content.find('p').has('img').css('textIndent', '0em');
			$content.find('img').each(function() {
				let $img = $(this);
				const realW = $img.attr('width');
				const realH = $img.attr('height');
				if(realW && realW < contentW / 2) {
					$img.css({
						'width': realW + 'px',
						'height': 'auto'
					});
				}
				else {
					$img.css({
						'width': '100%',
						'height': 'auto'
					});
				}
				$img.attr('src', vm.webp($img.attr('src')));
			});
			return $content.html();
		},
		showMedias() {
			const medias = this.detail.medias;
			if(Jt.array.isEmpty(medias)) {
				return false;
			}
			return true;
		},
		videoH() {
			return (this.appW - 20) / 2 + 'px';
		}
	},
	watch: {
		'$route': function() {
			this.init({
				sysCode:this.$route.params.sysCode,
				id:this.$route.params.id,
				date:this.$route.params.date,
			})
		},
		'detail': function(newVal, oldVal) {
			if(!Jt.object.isEmpty(newVal)) {
				this.$nextTick(function() {
					this.calcContentHeight();
				});
			}
		}
	},
	created() {
		console.log(this.$route)
		this.init({
			sysCode:this.$route.params.sysCode,
			id:this.$route.params.id,
			date:this.$route.params.date,
		});
	},
	methods: {
		...mapActions({
			init: 'paper:init'
		}),
		calcContentHeight() {
			let $content = $(this.$el).find('.m-content');
			let deviceH = device.height;
			let contentH = $content.height();
			let tempH = 0, showH = 0, collapse = false;
			if(contentH >= deviceH * 3 && contentH <= deviceH * 4) {
				collapse = true;
				showH = deviceH * 2.5;
			}
			else if(contentH >= deviceH * 4) {
				collapse = true;
				showH = deviceH * 3.5
			}
			if(collapse) {
				let $pEls = $content.find('p');
				if($pEls.length < 2) {
					return;
				}
				$(this.$el).find('.open-full-btn').css('display', 'block');
				this.openFull = false;
				$pEls.each(function() {
					tempH += $(this).height();
					if(tempH >= showH) {
						$(this).addClass('f-dn');
					}
				});
			}
		},
		openFullHandle() {
			$(this.$el).find('.open-full-btn').hide();
			$(this.$el).find('.m-content p.f-dn').show();
		}
	}
}

</script>


// WEBPACK FOOTER //
// page-paper.vue?2091b98c